angular.module 'zc.projects'

.directive 'zcProjectNotification',(Project, $stateParams, $state, $rootScope) ->
  restrict: 'E'
  templateUrl: '/templates/projects/directives/project_notification.html'

  link: (scope, element, attrs) ->
    Project.getCurrent($stateParams.projectId)
    .then (project) ->
      scope.project = project
      scope.showTimezoneAlert =
        moment().tz(project.region).format('Z') != moment().tz(moment.tz.guess(true)).format('Z')

    scope.isAlert = true
    scope.removeAlert = ->
      scope.isAlert = !scope.isAlert

    $rootScope.$on '$stateChangeSuccess', () ->
      if $state.current.name in [
        'admin.projects.campaigns.edit.schedule',
        'admin.projects.campaigns.edit.confirm',
        'admin.projects.incentives.new',
        'admin.projects.incentives.edit'
      ]
        scope.isAlert = true
        scope.isCriticalTimezoneAlert = true
      else
        scope.isCriticalTimezoneAlert = false



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/directives/project_notification.js.coffee